import { PATHS } from 'src/common/constants';
import captureException from 'src/common/utils/captureException';

const searchPathFromReferer = (referrer?: string | null): string | null => {
  if (referrer) {
    try {
      const url = new URL(referrer);
      if (url.host.endsWith('getmyboat.com')) {
        const pathWithParams = url.href.split(PATHS.SEARCH)[1];
        if (pathWithParams) {
          return pathWithParams;
        }
      }
    } catch (error) {
      captureException(`searchPathFromReferer: ${error}`);
    }
  }
  return null;
};

export default searchPathFromReferer;
